import React from 'react';

function Portfolio() {
    return <p>portfolio</p>;
}

export default Portfolio;